module.exports = "<div class=\"image-uploader\" layout=\"column\">\n  \n  <input class=\"image-file-input ng-hide\" name=\"imageFileInput\" type=\"file\" accept=\"image/*\">\n\n  <md-button class=\"md-raised md-primary\" ng-disabled=\"disabled\" ng-click=\"select()\" style=\"left: 708px; width:285px\">\n    <md-icon md-font-icon=\"fa fa-cloud-upload\"></md-icon>\n    UPLOAD AN IMAGE\n  </md-button>  \n  \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./product-list/image-uploader/tpl.html
// module id = 1139
// module chunks = 0